export default {"src":"/_next/static/media/link.d6c73ef4.svg","height":17,"width":16,"blurWidth":0,"blurHeight":0};